import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import InputForm from 'app/commons/components/InputForm';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

export default function SearchForm({ setDataParams }) {
  const router = useRouter()
  const { t } = useTranslation();
  const [keyword, setKeyword] = useState(router.query.keyword || '')

  useEffect(() => {
    return () => setKeyword('');
  }, []);

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      setDataParams(e.target.value, 'keyword', 1);
    }
  }

  return (
    <div id="form-search" className="form-group position-relative">
      <InputForm
        value={keyword}
        name="form-search"
        handleChange={(value: string) => setKeyword(value)}
        onKeyDown={(e) => handleEnter(e)}
        placeholder={t('actions.search')}
        className="input-search"
      />
      <FontAwesomeIcon
        onClick={() => setDataParams(keyword as string, 'keyword', 1)}
        style={{ marginTop: 2 }}
        className="position-absolute cursor-pointer icon-search"
        icon={faSearch}
      />
      <style jsx global>{`
        #form-search .icon-search {
          top: 6px;
          font-size: 20px;
          color: #747272;
          right: 8px !important;
        }
        #form-search .input-search {
          padding-right: 35px !important;
        }
      `}
      </style>
    </div>
  )
}
